// src/routes/AdminRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../services/authService';

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  if (!isAuthenticated() || !isAdmin()) {
    return <Navigate to="/login" replace state={{ returnPath: window.location.pathname }} />;
  }
  return <>{children}</>;
};

export default AdminRoute;
